import { Card, CardBody } from '@vnetwork/ui/primitives';
import { InfoGrid } from '@/pages/account/components/InfoGrid';
import { formatDate } from '@/lib/format';
import type { EmployeeRecord } from '@/api/employees';

interface Props { emp: EmployeeRecord }

const GENDER_LABEL: Record<string, string> = {
  male: 'Male', female: 'Female', other: 'Other',
};
const MARRIAGE_LABEL: Record<string, string> = {
  single: 'Single', married: 'Married', divorced: 'Divorced', widowed: 'Widowed', undetermined: 'Undetermined',
};

/**
 * Personal tab — basic personal facts: contact, birthday, identity origin,
 * and emergency contact (contact_homies). Read-only InfoGrid.
 */
export function EmployeeTabPersonal({ emp }: Props) {
  // contact_homies may come back as {} (empty object) when unset
  const homies = Array.isArray(emp.contact_homies) ? emp.contact_homies : [];
  const firstContact = homies[0];

  return (
    <div style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>
      <Card flat>
        <CardBody>
          <InfoGrid
            items={[
              { label: 'Full name', value: emp.employee_name },
              { label: 'Employee code', value: emp.employee_code },
              { label: 'Personal email', value: emp.employee_email },
              { label: 'Company email', value: emp.employee_email_company },
              { label: 'Phone', value: emp.employee_phone_number },
              { label: 'Gender', value: GENDER_LABEL[emp.employee_gender] ?? emp.employee_gender },
              { label: 'Birthday', value: formatDate(emp.employee_birthday) },
              { label: 'Marriage', value: MARRIAGE_LABEL[emp.employee_marriage] ?? emp.employee_marriage },
              { label: 'Birthplace', value: emp.employee_birthplace },
              { label: 'Original place', value: emp.employee_original_place },
              { label: 'Nation', value: emp.employee_nation },
              { label: 'Nationality', value: emp.employee_nationality },
              { label: 'Religion', value: emp.employee_religion },
            ]}
          />
        </CardBody>
      </Card>

      {firstContact ? (
        <Card flat>
          <CardBody>
            <p style={{
              margin: '0 0 var(--vn-space-3)',
              fontSize: 'var(--vn-font-size-sm)',
              fontWeight: 'var(--vn-font-weight-semibold)',
              color: 'var(--vn-fg-default)',
            }}>
              Emergency contact
            </p>
            <InfoGrid
              items={[
                { label: 'Relationship', value: firstContact.contact_relationship },
                { label: 'Phone', value: firstContact.contact_phone },
                { label: 'Name', value: firstContact.contact_name },
              ]}
            />
          </CardBody>
        </Card>
      ) : null}
    </div>
  );
}
